import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_429_1391",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_429_1391)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.0752 20.5002C6.6416 20.5002 6.2708 20.346 5.9628 20.0376C5.6544 19.7292 5.5002 19.3584 5.5002 18.9252V5.62504H4.5V4.37524H8.85V3.62524H15.15V4.37524H19.5V5.62504H18.4998V18.9252C18.4998 19.3584 18.3456 19.7292 18.0372 20.0376C17.7292 20.346 17.3584 20.5002 16.9248 20.5002H7.0752ZM17.2248 5.62504H6.7752V18.9252C6.7752 19.0084 6.8044 19.0834 6.8628 19.1502C6.9208 19.2166 6.9916 19.2498 7.0752 19.2498H16.9248C17.0084 19.2498 17.0792 19.2166 17.1372 19.1502C17.1956 19.0834 17.2248 19.0084 17.2248 18.9252V5.62504ZM9.4998 17.175H10.7502V7.69984H9.4998V17.175ZM13.2498 17.175H14.5002V7.69984H13.2498V17.175ZM6.7752 5.62504V19.2498V18.9252V5.62504Z",
				fill: "#EF476F"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
